<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>

        <div class="ibox ">
            <div class="ibox-title">
                <h5>Obavijesti</h5>
            </div>
            <div class="ibox-content">
                <email-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                >
                </email-forma>
            </div>
        </div>
    </div>
</template>

<script>
import EmailForma from "@/views/pages/Skupovi/Emails/EmailForma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
    name: "EmailCreate",
    components:{
        EmailForma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id,
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/emails',
                    name: 'Obavijesti'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/emails/create',
                    name: 'Nova obavijest'
                }
            ]
        },

    },
    mounted() {
        this.setBreadcrumbs()
    }

}
</script>

<style scoped>

</style>
